import PazienteAccettazione from "../";

const routes = [
    { name: "Elenco Accettazioni", path: "/pazienteaccettazione", component: PazienteAccettazione.PazienteAccettazioneList, meta: { title: "Elenco Accettazione" } },
    { name: "AccettazioniEdit", path: "/pazienteaccettazione/edit/:id", component: PazienteAccettazione.PazienteAccettazioneEdit, meta: { title: "Accettazione" } },
    { name: "PazienteAccettazioneView", path: "/pazienteaccettazione/view/:id", component: PazienteAccettazione.PazienteAccettazioneView, meta: { title: "Accettazione" } },
];

export default routes;
